import { render, staticRenderFns } from "./AudioRecordingModal.vue?vue&type=template&id=178872d5&scoped=true&"
import script from "./AudioRecordingModal.vue?vue&type=script&lang=js&"
export * from "./AudioRecordingModal.vue?vue&type=script&lang=js&"
import style0 from "./AudioRecordingModal.vue?vue&type=style&index=0&id=178872d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178872d5",
  null
  
)

export default component.exports